<!-- 
Dialog for viewing the content of a notice.
-->
<template>
  <v-dialog :value="show" scrollable content-class="dialog lg" @keydown.esc="hide" >
    <v-card>
      <v-toolbar color="secondary" flat dark>
        <v-toolbar-title>
          {{ title }}
          <span v-if="subtitle" class="body-1">{{ subtitle }}</span>
        </v-toolbar-title>
        <v-spacer/>
        <our-user-guide-button topic="listing-notices" section="viewing-a-sent-notice" />
      </v-toolbar>
      <our-busy-indicator :show="state.loading"/>
      <v-card-text v-if="!state.loading">
        <our-data-container dense>
          <our-data-field label="Date">{{ noticeDate | compactDateTime }}</our-data-field>
        </our-data-container>
        <notice-email-panel :notice="notice" />
      </v-card-text>
      <v-card-actions>
        <v-btn 
          v-if="canResend" 
          :disabled="state.loading" 
          color="primary" flat 
          @click="resend"
        >
          Resend notice
        </v-btn>
        <v-spacer/>
        <v-btn :disabled="state.loading" color="primary" flat @click="hide">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NoticeEmailPanel from "@/components/notices/NoticeEmailPanel.vue";
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/notices/action-types";
import { NOTICES_RESEND } from "@/store/claim-types";

export default {
  components: {
    NoticeEmailPanel
  },
  mixins: [filterMixins, lookupMixins],
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    noticeId: {
      type: Number,
      default: null
    },
    preventResend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state() {
      return this.$store.state.notices.view;
    },
    notice() {
      return this.state.data;
    },
    noticeDate() {
      return this.notice.date;
    },
    templateTypeText() {
      return this.lookups.noticeTypeDescriptions[this.notice.type];
    },
    canResend() {
      return !this.preventResend && this.notice.canResend && this.$store.getters.claims.includes(NOTICES_RESEND);
    },
    title() {
      return !this.state.loading ? `${this.templateTypeText}` : "Notice";
    },
    subtitle() {
      return !this.state.loading ? `${this.levyCollection} - ${this.providerName}` : "";
    },
    levyCollection() {
      return !this.loading ? this.notice.levyCollection : null;
    },
    levyCollectionId() {
      return this.notice.levyCollectionId;
    },
    providerId() {
      return this.notice.providerId;
    },
    providerName() {
      return !this.loading ? this.notice.providerName : null;
    }
  },
  watch: {
    show(showing) {
      if (showing) this.load();
    }
  },
  methods: {
    async load() {
      await this.$store.dispatch(action.VIEW, this.noticeId);
      this.$emit("loaded");
    },
    resend() {
      this.hide();
      this.$emit("resend");
    },
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
